/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { Locale } from '@/types/i18n';
import { locationsPrefix } from '../constants/locationsPrefix';

const FIRST_PATH_COMPONENT = /(^\/[^/?#]*)/;

export function isValidLocationsLocale(asPath: string, locale: Locale): boolean {
  const root = FIRST_PATH_COMPONENT.exec(asPath)?.[0];
  return Boolean(root && root === `/${locationsPrefix[locale]}`);
}
